<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.services.' + listitemId + '.data.name'"
            :data-preset="'Listpresets.services'"
            :data-default="{ type: 'raw', value: 'Ihre Dienstleistung' }"
            required
            :maxlength="255"
        ></app-text>

        <!--
        <app-wysiwyg
            label="Überschrift"
            :data-source="'deha.user.misc.services.' + listitemId + '.data.title'"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>
        -->

        <app-filepicker
            label="Bild"
            :data-source="'deha.user.misc.services.' + listitemId + '.data.image'"
            accept=".jpg,.png,.gif"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl', 'getActiveIconstyle'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R022'),
            help: this.$helpers.uiText('R023'),
            removeText: this.$helpers.uiText('R096')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg,
        'app-filepicker': Filepicker
    }
};
</script>
